import React from 'react'

import SendEmail from './SendEmail'
import ChangePassword from './ChangePassword'
import useSearchParams from 'lib/hooks/useSearchParams'
import Layout, { Right } from 'layouts'
import Anchor from 'components/Anchor'
import { Link } from 'react-router-dom'

const ResetPassword = () => {
  const { code } = useSearchParams()

  return (
    <Layout>
      <Right className='tracking-wide'>
        already have an account?{' '}
        <Anchor className='ml-1' component={Link} to='/signin'>
          Log in
        </Anchor>
      </Right>
      <div className='flex-grow xs:p-11 px-4 pt-12 mx-auto max-w-md'>
        <div>{code ? <ChangePassword /> : <SendEmail />}</div>
      </div>
    </Layout>
  )
}

export default ResetPassword
